import { useEffect, useState } from "react";
import { LAUNCH_DATE } from "@/lib/api";

const calc = (target) => {
  const diff = target.getTime() - Date.now();
  const clamp = Math.max(diff, 0);
  return {
    days: Math.floor(clamp / 86400000),
    hours: Math.floor((clamp / 3600000) % 24),
    minutes: Math.floor((clamp / 60000) % 60),
    seconds: Math.floor((clamp / 1000) % 60),
  };
};

export const Countdown = ({ light = false, target = LAUNCH_DATE }) => {
  const [t, setT] = useState(calc(target));

  useEffect(() => {
    const i = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(i);
  }, [target]);

  const units = [
    { label: "Days", value: t.days },
    { label: "Hours", value: t.hours },
    { label: "Minutes", value: t.minutes },
    { label: "Seconds", value: t.seconds },
  ];

  const border = light ? "border-wine/20" : "border-gold/25";
  const num = light ? "text-wine" : "text-cream";
  const lab = light ? "text-wine/60" : "text-gold";

  return (
    <div data-testid="countdown" className="flex items-stretch gap-3 sm:gap-4">
      {units.map((u, i) => (
        <div key={u.label} className="flex items-center gap-3 sm:gap-4">
          <div className="text-center">
            <div className={`font-display font-medium leading-none ${num} text-5xl sm:text-6xl tabular-nums`}>
              {String(u.value).padStart(2, "0")}
            </div>
            <div className={`mt-2 font-mono text-[10px] uppercase tracking-[0.25em] ${lab}`}>{u.label}</div>
          </div>
          {i < units.length - 1 && <div className={`w-px h-12 self-start mt-1 border-l ${border}`} />}
        </div>
      ))}
    </div>
  );
};
